<template>
  <page>
    <div>
      <v-flex xs12>
        <form>
          <v-expansion-panels>
          <v-expansion-panel>
              <v-expansion-panel-header>
              <div>
                <v-icon>mdi-filter-variant</v-icon> Filters
              </div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
              <v-card>
                <v-card-text>
                  <v-container fluid grid-list-lg>
                    <v-layout row wrap>
                      <v-flex md6>
                        <v-text-field v-model="filters.accmType" :label="labels.accmType" :error-messages="errors.collect('accmType')" data-vv-name="accmType" :data-vv-as="labels.accmType" v-validate="'max:2'"></v-text-field>
                      </v-flex>
                      <v-flex md6>
                        <v-text-field v-model="filters.blkGrp" :label="labels.blkGrp" :error-messages="errors.collect('blkGrp')" data-vv-name="blkGrp" :data-vv-as="labels.blkGrp" v-validate="'max:10'"></v-text-field>
                      </v-flex>
                    </v-layout>
                    <v-layout row wrap>
                      <v-flex md6>
                        <v-text-field v-model="filters.blkS1grp" :label="filterLabel.blkS1grp" :error-messages="errors.collect('blkS1grp')" data-vv-name="blkS1grp" :data-vv-as="filterLabel.blkS1grp" v-validate="'max:10'"></v-text-field>
                      </v-flex>
                      <v-flex md6>
                        <v-text-field v-model="filters.blkS2grp" :label="filterLabel.blkS2grp" :error-messages="errors.collect('blkS2grp')" data-vv-name="blkS2grp" :data-vv-as="filterLabel.blkS2grp" v-validate="'max:10'"></v-text-field>
                      </v-flex>
                    </v-layout>
                    <v-layout row wrap>
                      <v-flex md6>
                        <v-text-field v-model="filters.blk" :label="labels.blk" :error-messages="errors.collect('blk')" data-vv-name="blk" :data-vv-as="labels.blk" v-validate="'max:15'"></v-text-field>
                      </v-flex>
                      <v-flex md6>
                        <v-text-field v-model="filters.riType" :label="labels.riType" :error-messages="errors.collect('riType')" data-vv-name="riType" :data-vv-as="labels.riType" v-validate="'max:1'"></v-text-field>
                      </v-flex>
                    </v-layout>
                    <v-layout row wrap>
                      <v-flex md6>
                        <v-text-field v-model="filters.ttyNo" :label="labels.ttyNo" :error-messages="errors.collect('ttyNo')" data-vv-name="ttyNo" :data-vv-as="labels.ttyNo" v-validate="'max:8'"></v-text-field>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="red darken-1" text @click.native="doClearFilters">Clear Filters</v-btn>
                  <v-btn color="primary" text type="submit" @click.prevent="doFilters">Apply Filters</v-btn>
                </v-card-actions>
              </v-card>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
        </form>
      </v-flex>
      <v-spacer class="mt-1"></v-spacer>
      <v-card>
        <v-flex xs12>
          <message :messages="messages"></message>
        </v-flex>
        <v-card-title>
          <v-spacer></v-spacer>
          <v-btn color="primary" dark class=" mr-2" @click="doNew">
            New Block Treaty Limit
            <v-icon right>mdi-plus</v-icon>
          </v-btn>
        </v-card-title>
        <v-flex xs12>
          <v-card>
            <v-data-table :headers="headers" :items="items" v-bind:options.sync="pagination" :server-items-length="totalItems" :loading="loading" :footer-props="{'items-per-page-options': itemsPerPage }" :no-data-text="noDataText">
              <template v-slot:item="row"><tr>
                <td>{{ row.item.accmType }}</td>
                <td class="text-xs-left">{{ row.item.blkGrp }}</td>
                <td class="text-xs-left">{{ row.item.blksGrp1 }}</td>
                <td class="text-xs-left">{{ row.item.blksGrp2 }}</td>
                <td class="text-xs-left">{{ row.item.blk }}</td>
                <td class="text-xs-left">{{ row.item.riType }}</td>
                <td class="text-xs-left">{{ row.item.ttyNo }}</td>
                <td class="text-xs-left">{{ row.item.ttyLim }}</td>
                <td class="text-xs-left">{{ row.item.noLines }}</td>
                <td class="table-action-header">
                  <table-action :rowData="row" review @review="doAction('edit', row.item)" query @query="doAction('query', row.item)" remove @remove="doPromptRemove"></table-action>
                </td>
              </tr></template>
            </v-data-table>
          </v-card>
        </v-flex>
      </v-card>
      <confirm v-model="promptRemove" @ok="doRemove">
        Are you sure you want to remove the selected Block Treaty Limit?
        <div class="queryValue">AccumType: {{selected.accmType}}<br/>
          Block Group: {{selected.blkGrp}}<br/>
          Block Sub Group 1: {{selected.blkS1grp}}<br/>
          Block Sub Group 2: {{selected.blkS2grp}}<br/>
          Block: {{selected.blk}}<br/>
          RI Type: {{selected.riType}}<br/>
          Treaty No.: {{selected.ttyNo}}<br/>
        </div>
      </confirm>
    </div>
  </page>
</template>

<script>
import * as TableConst from '@/mixins/table'
import MessageMixin from '@/mixins/message'
import { expandURI, filterQuery } from '@/utils/ajax'
import { formatPrice } from '@/utils/index'

export default {
  data() {
    return {
      toogleArray: [false],
      headers: [
        { text: 'Accumulation Type', align: 'left', value: 'accmType' },
        { text: 'Block Group', align: 'left', value: 'blkGrp' },
        { text: 'Block Sub Group 1', align: 'left', value: 'blksGrp1' },
        { text: 'Block Sub Group 2', align: 'left', value: 'blksGrp2' },
        { text: 'Block', align: 'left', value: 'blk' },
        { text: 'RI Type', align: 'left', value: 'riType' },
        { text: 'Treaty No.', align: 'left', value: 'ttyNo' },
        { text: 'Treaty Limit', align: 'left', value: 'ttyLim' },
        { text: 'No. of Lines', align: 'left', value: 'noLines' },
        TableConst.tableActionHeader
      ],
      filters: {
        accmType: undefined,
        blk: undefined,
        blkGrp: undefined,
        blkS1grp: undefined,
        blkS2grp: undefined,
        riType: undefined,
        ttyNo: undefined
      },
      filterLabel: {
        blkS1grp: 'Block Sub Group 1',
        blkS2grp: 'Block Sub Group 2'
      },
      labels: {
        accmType: 'Accumulation Type',
        blk: 'Block',
        blkGrp: 'Block Group',
        blksGrp1: 'Block Sub Group 1',
        blksGrp2: 'Block Sub Group 2',
        limType: 'Limit Type',
        riType: 'RI Type',
        ttyNo: 'Treaty No.',
        acctNoSfx: 'Account No. Suffix'
      },
      totalItems: 0,
      promptRemove: false,
      selected: {
        accmType: undefined,
        blk: undefined,
        blkGrp: undefined,
        blkS1grp: undefined,
        blkS2grp: undefined,
        limType: undefined,
        riType: undefined,
        ttyNo: undefined,
        acctNoSfx: undefined,
        ttyLim: undefined,
        esclPct: undefined,
        noLines: undefined,
        ownRtn: undefined
      },
      loading: false,
      accmTypeList: [],
      pagination: {
        sortDesc: [false],
        page: 1
      }
    }
  },
  computed: {
    menu() {
      return this.$store.state.blkParam.menu
    }
  },
  watch: {
    'pagination': function (value) {
      this.doInit(false)
    }
  },
  methods: {
    async doInit(options) {
      const apiURI = this.menu.getBlkTtyLimList
      if (apiURI) {
        this.loading = true
        try {
          const { page, itemsPerPage } = this.pagination
          let expand = {
            page: page - 1,
            size: itemsPerPage,
            options: options
          }
          const result = await this.$http.get(filterQuery(expandURI(apiURI, expand), this.filters, this.pagination.sortBy, this.pagination.sortDesc))
          this.items = []
          if (result) {
            this.totalItems = result.data.totalElements
            const { data } = result.data
            this.items = []
            if (data) {
              data.map((datamap) => {
                const convertList = {
                  accmType: datamap.accmType,
                  blk: datamap.blk,
                  blkGrp: datamap.blkGrp,
                  blksGrp1: datamap.blkS1grp,
                  blksGrp2: datamap.blkS2grp,
                  limType: datamap.limType,
                  riType: datamap.riType,
                  ttyNo: datamap.ttyNo,
                  acctNoSfx: datamap.acctNoSfx,
                  ttyLim: formatPrice(Number(datamap.ttyLim)),
                  esclPct: datamap.esclPct,
                  noLines: datamap.noLines,
                  ownRtn: datamap.ownRtn
                }
                this.items.push(convertList)
              })
            }
          }
          this.loading = false
        } catch (err) {
          this.loading = false
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    },
    doNew() {
      this.$router.push({
        name: 'blkTtyLimReview',
        params: {
          mode: 'new',
          id: {}
        }
      })
    },
    doAction(mode, data) {
      this.$router.push({
        name: 'blkTtyLimReview',
        params: {
          mode: mode,
          id: data
        }
      })
    },
    async getAccmTypeList() {
      const apiURI = this.menu.getAccmTypeList
      if (apiURI) {
        const result = await this.$http.get(apiURI)
        const { data } = result.data
        this.accmTypeList = []
        if (data) {
          data.map((accmType) => {
            const convertList = {
              label: accmType.accmType + ' - ' + accmType.accmTypeDesc,
              value: accmType.accmType
            }
            this.accmTypeList.push(convertList)
          })
        }
      }
    },
    doPromptRemove(data) {
      this.resetMessages()
      this.selected = data.item
      this.selected.accmType = data.item.accmType
      this.selected.blkGrp = data.item.blkGrp
      this.selected.blkS1grp = data.item.blksGrp1
      this.selected.blkS2grp = data.item.blksGrp2
      this.selected.limType = data.item.limType
      this.selected.blk = data.item.blk
      this.selected.riType = data.item.riType
      this.selected.ttyNo = data.item.ttyNo
      this.selected.acctNoSfx = data.item.acctNoSfx
      this.selected.ttyLim = data.item.ttyLim
      this.selected.esclPct = data.item.esclPct
      this.selected.noLines = data.item.noLines
      this.selected.ownRtn = data.item.ownRtn
      this.promptRemove = true
    },
    doRemove() {
      const apiURI = this.menu.deleteBlkTtyLim
      if (apiURI) {
        const expand = this.selected
        this.$http
          .post(apiURI, expand)
          .then((result) => {
            const data = result.data
            this.notify(data)
            this.promptRemove = false
            this.doInit(true)
          })
          .catch((err) => {
            this.promptRemove = false
            const { data } = err.response
            this.message(data)
          })
      }
    },
    doClearFilters() {
      this.resetMessages()
      this.filters.accmType = undefined
      this.filters.blk = undefined
      this.filters.blkGrp = undefined
      this.filters.blkS1grp = undefined
      this.filters.blkS2grp = undefined
      this.filters.riType = undefined
      this.filters.ttyNo = undefined
      this.pagination.page = 1
      this.doInit(false)
    },
    doFilters() {
      this.resetMessages()
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.pagination.page = 1
          this.doInit(false)
        } else {
          this.promptFieldCheck()
        }
      })
    }
  },
  mounted() {
    this.doInit(true)
    this.getAccmTypeList()
  },
  mixins: [TableConst.default, MessageMixin]
}
</script>
